import { ESRI } from '../../constants/mapProviders';

/**
 * Show a marker instance based on the map provider
 * @param {Object} mapObject - map object
 * @param {Instance} marker - instance of the marker
 */
const showMarker = (mapObject, marker) => {
  switch (mapObject.mapProvider) {
    case ESRI: {
      marker.visible = true;
      break;
    }
  }
};

export default showMarker;
